export const landingTypesList: string[] = [
  '/',
  '/fullPrice',
  // '/type1',
  // '/type2',
  // '/type3',
];
